<template >
  <div>
    <div class="mf_purple_info fp_step">{{ title }}</div>
    <div class="fp_step_title">{{ subtitle }}</div>
  </div>
</template>
<script>
export default { props: ["title", "subtitle"] };
</script>
<style lang="scss">
@import "./resources/sass/_variables.scss";

.fp_step_title {
  color: $lt_grey_color;
}

.fp_step {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
}
</style>